import { AppliedLessonType } from '@/enums/AppliedLessonType';

export function appliedLessonTypeFromQuery(query: Record<string, any>): AppliedLessonType {
    const type = query.type;
    if (type === 'pm') {
        return AppliedLessonType.PMAppliedLesson;
    }
    if (type === 'x') {
        return AppliedLessonType.XAppliedLesson;
    }
    return AppliedLessonType.AppliedLesson;
}
